export enum ContactType {
  phone = "PHONE",
  // fax = "FAX",
  email = "EMAIL",
  // pager = "PAGER",
  url = "URL",
  // sms = "SMS",
  // other = "OTHER",
}
